<template>
  <img
    v-if="generalStore.customer()[logoKey]"
    :src="getFilestoreUrl(generalStore.customer()[logoKey] || '')"
    alt="Logo"
    class="w-full h-full object-contain object-left"
  />
  <SafeticketLogo v-else class="w-full h-full object-contain object-left" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

  import { useGeneralStore } from '@/stores/general';
  import { getFilestoreUrl } from '@/utils/filestoreUtil';

  import SafeticketLogo from '../icons/SafeticketLogo.vue';

  const generalStore = useGeneralStore();

  const props = defineProps({
    useFooterLogo: {
      type: Boolean,
      default: false,
    },
  });

  const logoKey = computed(() => (props.useFooterLogo ? 'logoFooter' : 'logo'));
</script>
